
import { Amplify } from 'aws-amplify';
import '@aws-amplify/ui-react/styles.css';
import awsexports from './aws-exports';
import { FaceLivenessDetector } from '@aws-amplify/ui-react-liveness';
import { defaultLivenessDisplayText } from './displayText.js'
import { Loader, ThemeProvider, Flex, View, Alert } from '@aws-amplify/ui-react';

Amplify.configure(awsexports);

const FaceLiveness = ({ GetSessionId, createLivenessApiData, handleAnalysisComplete, resetAll, setShowAwsSelfie, sending }) => {


    return sending ? <Loader /> : <ThemeProvider> <View height="100vh" maxHeight="100vh" id="view-fld">
        <FaceLivenessDetector

            sessionId={createLivenessApiData.sessionId}
            disableStartScreen={true}
            region="us-east-1"
            onAnalysisComplete={handleAnalysisComplete}
            displayText={defaultLivenessDisplayText}
            onError={(error) => {
                console.error(error.state);
                console.error(error.error);
                setShowAwsSelfie(false)
            }}
            onUserCancel={resetAll}

            components={{
                PhotosensitiveWarning: () => {
                    return (<Alert
                        variation="warning"
                        isDismissible={false}
                        hasIcon={true}
                        heading="Precaución"
                    >
                        Esta verificación muestra luces de colores. Tenga cuidado si es fotosensible.
                    </Alert>)

                },
                ErrorView: ({ children }) => {
                    return (
                        <View flex="1" backgroundColor="white" textAlign="center">

                            <div style={{ marginTop: "50px" }}>{children}</div>
                            <br />
                            <br />
                            <button onClick={GetSessionId}>Volver a intentar</button>
                        </View>
                    );
                }
            }}

        />
    </View>   </ThemeProvider>
}

export default FaceLiveness;